import gql from 'graphql-tag';

const NAME =
  'compositions_CaseRequestsPanel_RequestAssetsForm_deleteAssetsMutation';

export default gql`
  mutation ${NAME} ($ids: [ID!]!) {
    deleteAssets(input: { ids: $ids }) {
      deletedCount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestAssetActions/deleteAssetsMutation.js